function openMenu(menu) {
    menu.classList.add('fpaMobileMenu--open');
}

function closeMenu(menu) {
    menu.classList.remove('fpaMobileMenu--open');
}

function initMenu(openButton) {
    const menuId = openButton.getAttribute('data-for-fpa-mobile-menu');
    let menu, closeButton;

    if (menuId) {
        menu = document.querySelector(`[data-fpa-mobile-menu="${menuId}"]`);
    }

    if (menu) {
        closeButton = menu.querySelector('.js_fpaMobileMenu__closeButton');
        openButton.addEventListener('click', e => openMenu(menu));
        closeButton.addEventListener('click', e => closeMenu(menu));
    }
}

function init() {    
    const openButtons = document.querySelectorAll('.js_fpaMobileMenu__openButton');

    openButtons.forEach(initMenu);
}

module.exports = init;
